import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Meantime() {
  return (
    <section className="meantime p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>In The Meantime</h2>
            <p>
              Check out our onsite blogs and our portfolio to learn more about
              TekRevol’s business.
            </p>
            <div className="meantime_btn">
              <Link
                to="/projects"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Explore Our Portfolio
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  fill="none"
                  viewBox="0 0 13 12"
                >
                  <path
                    fill="#fff"
                    d="M.703 9.976a.75.75 0 00.992 1.126L.703 9.976zm11.577-8.5a.75.75 0 00-.702-.795L4.842.257a.75.75 0 00-.095 1.498l5.989.376-.377 5.988a.75.75 0 101.497.094l.424-6.736zM1.695 11.103l10.332-9.11-.992-1.125L.703 9.977l.992 1.125z"
                  ></path>
                </svg>
              </Link>
              <Link
                to="https://www.tekrevol.com/blogs/"
                className="border_btn dark_btn meantime_left_btn"
                aria-label="TekRevol Contact"
              >
                Visit Our Blogs
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  fill="none"
                  viewBox="0 0 13 12"
                >
                  <path
                    fill="#fff"
                    d="M.703 9.976a.75.75 0 00.992 1.126L.703 9.976zm11.577-8.5a.75.75 0 00-.702-.795L4.842.257a.75.75 0 00-.095 1.498l5.989.376-.377 5.988a.75.75 0 101.497.094l.424-6.736zM1.695 11.103l10.332-9.11-.992-1.125L.703 9.977l.992 1.125z"
                  ></path>
                </svg>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Meantime;
